const initialState = {
  video: null, // media object
  isOpen: false
};

export const videoViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_VIDEO_VIEWER": {
      return initialState;
    }
    case "SET_VIDEO_VIEWER": {
      return { ...state, ...action.videoViewer };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/video-viewer.js